import {
  StudentExamAreaFilterParams,
  StudentExamFilterParams,
  getStudentExam,
  listStudentExamActivitiesProgress,
  listStudentExamCorrection,
  listStudentExams,
} from '@/data/services/studentExamServices';

export const studentExamQueries = {
  all: ['studentExams'] as const,

  list: (filters: StudentExamFilterParams = {}) => ({
    queryKey: [...studentExamQueries.all, 'list', { filters }] as const,
    queryFn: () => listStudentExams(filters),
  }),

  get: (studentExamId: number) => ({
    queryKey: [...studentExamQueries.all, 'get', studentExamId] as const,
    queryFn: () => getStudentExam(studentExamId),
  }),

  activitiesProgress: (
    studentExamId: number,
    filters: StudentExamAreaFilterParams = {},
  ) => ({
    queryKey: [
      ...studentExamQueries.all,
      'activities-progress',
      studentExamId,
      { filters },
    ] as const,
    queryFn: () => listStudentExamActivitiesProgress(studentExamId, filters),
  }),

  correction: (
    studentExamId: number,
    filters: StudentExamAreaFilterParams = {},
  ) => ({
    queryKey: [
      ...studentExamQueries.all,
      'correction',
      studentExamId,
      { filters },
    ] as const,
    queryFn: () => listStudentExamCorrection(studentExamId, filters),
  }),
};
